<template>
  <base-modal modal-id="item-status" modalSize="lg">
    <template v-slot:header>
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        @click="$bvModal.hide('item-status')"
      >
        &times;
      </button>
    </template>
    <template v-slot:modal-body>
      <div class="customized-detail items-status" v-if="track_order_data">
        <div v-if="track_order_data.kitchen_history['in-progress'].length">
            <h5>{{ _T('Preparing Items') }}</h5>
             <div class="items-box">
                 <span v-for="item in track_order_data.kitchen_history['in-progress']" :key="item.entity_id">
                    <p>{{ getItemDetails(item.entity_id).name }}</p>
                 </span>
                 <!-- <span v-for="item in track_order_data.dispatch_history.new" :key="item.entity_id">
                    <p>{{ getItemDetails(item.entity_id).name }}</p>
                 </span> -->
             </div>
        </div>
        <div v-else>
            <h5>{{ _T('Preparing Items') }}</h5>
            <div class="items-box">
                <span>{{ _T('All Done') }} </span>
            </div>
        </div>
        <div class="items-separator" v-if="track_order_data.kitchen_history.finished.length || track_order_data.dispatch_history.finished.length">
            <h5>{{ _T('Ready Items') }}</h5>
            <div class="items-box">
                <template v-if="track_order_data.kitchen_history.finished.length">
                    <span v-for="item in track_order_data.kitchen_history.finished" :key="item.entity_id">
                        <p>{{ getItemDetails(item.entity_id).name }}</p>
                    </span>
                </template>
                <template v-if="track_order_data.dispatch_history.finished.length">
                    <span v-for="item in track_order_data.dispatch_history.finished" :key="item.entity_id">
                        <p>{{ getItemDetails(item.entity_id).name }}</p>
                    </span>
                </template>
                
            </div>
        </div>
        <!-- <div v-else class="items-separator">
            <h5>{{ _T('Ready Items') }}</h5>
            <div class="items-box">
                <span>{{ _T('All Done') }} </span>
            </div>
        </div> -->
        <div class="items-separator" v-if="track_order_data.dispatch_history.removed.length">
            <h5>{{ _T('Removed Items') }}</h5>
            <div class="items-box">
                <span v-for="item in track_order_data.dispatch_history.removed" :key="item.entity_id">
                    <p>{{ item.name }}</p>
                </span>
            </div>
        </div>
        <br>
      </div>
    </template>
    <template v-slot:modal-footer>
      <!--  -->
    </template>
  </base-modal>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import BaseModal from '@/components/Modals/BaseModal'

export default {
  name: 'ItemsStatus',
  components: {
    BaseModal,
  },
  computed: {
    ...mapState({
      openPopup: state => state.brand_store.openModifier,
      item: state => state.cart_store.selectedItem,
    }),
    ...mapGetters([
      '_T_DB',
      '_T',
      'track_order_data',
      'itemModifierGroups',
      'itemModifierSubGroups',
      'itemModifiers',
    ]),
  },
  data () {
    return {
      // closepopup: false,
      // selectSingleItemClick: '',
    }
  },
  // props: { isModalVisible: Boolean },
  methods: {
    getItemDetails(entityId) {
        return this.track_order_data.items.find(item => item.entity_id == entityId)
    },
    close () {
      this.$store.commit('SET_ITEM_DETAIL_POPUP')
    },
  },
}
</script>

<style lang="scss" scoped>

#item-status___BV_modal_header_  {
    &.modal-header {background-color:lightgrey !important;}
    .close {
        display: block;
    }
}
.items-box{
    border-bottom: 1px solid #ccc;
    border-top: 1px solid #ccc;
    padding: 10px 5px;
}
.items-separator {
    padding-top: 10px;
}
.items-status {
    h5 { 
        font-weight: bold;
    }
}
</style>
